var map = {
	"./modules/confirm/confirm.module": [
		"./src/app/modules/confirm/confirm.module.ts",
		"modules-confirm-confirm-module"
	],
	"./modules/dashboard/dashboard.module": [
		"./src/app/modules/dashboard/dashboard.module.ts",
		"modules-dashboard-dashboard-module"
	],
	"./modules/login/login.module": [
		"./src/app/modules/login/login.module.ts",
		"modules-login-login-module"
	],
	"./modules/main-app/main-app.module": [
		"./src/app/modules/main-app/main-app.module.ts",
		"modules-main-app-main-app-module"
	],
	"./modules/pre-order/pre-order.module": [
		"./src/app/modules/pre-order/pre-order.module.ts"
	],
	"./modules/reset-password/reset-password.module": [
		"./src/app/modules/reset-password/reset-password.module.ts",
		"modules-reset-password-reset-password-module"
	],
	"./modules/sign-up/sign-up.module": [
		"./src/app/modules/sign-up/sign-up.module.ts"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;